// extracted by mini-css-extract-plugin
export default {"main":"NotificationHistory_main__l+TBQ","title":"NotificationHistory_title__4USG7","row":"NotificationHistory_row__rFxs4"};